import React, { useState, useEffect } from 'react';
import { Navigate, Link } from 'react-router-dom';
import { getLocationById } from '../data/locations';
import ContactForm from '../components/ContactForm';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FaArrowLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const SanJosePage: React.FC = () => {
  const location = getLocationById('san-jose');
  
  // Gallery carousel state
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  // SJ photo assets
  const sjPhotos = [
    '/assets/SJ_flat_1.jpeg',
    '/assets/SJ_flat_2.jpeg', 
    '/assets/SJ_flat_3.jpeg',
    '/assets/SJ_tall_1.jpeg',
    '/assets/SJ_tall_2.jpeg'
  ];

  // Auto-advance carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % sjPhotos.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [sjPhotos.length]);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % sjPhotos.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + sjPhotos.length) % sjPhotos.length);
  };

  if (!location) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="san-jose-page">
      <Header>
        <Link to="/" className="nav-back">
          {React.createElement(FaArrowLeft as React.ComponentType)} Back to Main
        </Link>
        <a href="#barbers">Barbers</a>
        <a href="#booking">Booking</a>
        <a href="#contact">Contact</a>
      </Header>

      {/* Page Header */}
      <section className="page-hero">
        <div className="page-hero-content">
          <div className="breadcrumb">
            <Link to="/">Home</Link> / <span>San Jose</span>
          </div>
          <h1>Metropolitan Barbershop</h1>
          <h2>San Jose Location</h2>
          <p>Experience the finest in classic barbering in San Jose</p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <div className="gallery-content">
            {/* Video */}
            <div className="gallery-video">
              <video
                autoPlay
                muted
                loop
                playsInline
                className="sj-video"
              >
                <source src="/assets/SJ_video.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            {/* Photo Carousel */}
            <div className="gallery-carousel">
              <div className="carousel-container">
                <button className="carousel-btn prev" onClick={prevImage}>
                  {React.createElement(FaChevronLeft as React.ComponentType)}
                </button>
                
                <div className="carousel-images">
                  <img
                    src={sjPhotos[currentImageIndex]}
                    alt={`San Jose Metropolitan Barbershop ${currentImageIndex + 1}`}
                    className="carousel-image"
                  />
                </div>
                
                <button className="carousel-btn next" onClick={nextImage}>
                  {React.createElement(FaChevronRight as React.ComponentType)}
                </button>
              </div>
              
              {/* Carousel Dots */}
              <div className="carousel-dots">
                {sjPhotos.map((_, index) => (
                  <button
                    key={index}
                    className={`dot ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={() => setCurrentImageIndex(index)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Barbers Section */}
      <section id="barbers" className="barbers">
        <div className="container">
          <h2>Meet Our San Jose Barbers</h2>
          <div className="coming-soon-barbers">
            <p>Our talented barber team will be announced soon!</p>
          </div>
        </div>
      </section>

      {/* Booking Section */}
      <section id="booking" className="booking">
        <div className="container">
          <div className="booking-content">
            <h2>Book Your Appointment</h2>
{location.bookingStatus === 'active' && location.bookingUrl ? (
              <>
                <p>Book your appointment at our {location.name} location</p>
                <div className="booking-info">
                  <a href={location.bookingUrl} className="btn btn-primary btn-large">
                    BOOK ONLINE - {location.name}
                  </a>
                  <div className="booking-details">
                    <div className="cash-only">
                      <strong>$CASH ONLY$</strong>
                      <p>An ATM is available in the barbershop and there are multiple others in the surrounding area.</p>
                    </div>
                    <div className="phone-booking">
                      <p>Also phone in for appointments:</p>
                      <p><strong>{location.city} {location.phone}</strong></p>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="booking-coming-soon">
                <h3>Booking Coming Soon!</h3>
                <p>Our {location.name} location will be opening soon. Stay tuned for booking availability!</p>
                <p>In the meantime, check out our <Link to="/san-francisco">San Francisco location</Link></p>
              </div>
            )}

            <div className="booking-policies">
              <div className="policy">
                <h4>CONFIRMATION REQUIRED</h4>
                <p>In unfortunate circumstances, online appointments may not go through. Make sure to check email for confirmation of appointment. If reschedule or cancellation is needed, a link is provided in the confirmation email. You can also call the shop to cancel or notify us if you'll be late.</p>
              </div>
              <div className="policy">
                <h4>10 MINUTE POLICY</h4>
                <p>Customers later than 10 minutes of appointment will not be able to be accommodated and can reschedule.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <ContactForm
        location={location}
        formsparkId="3T2xHoAqR"
        botpoisonKey="pk_634e5fe3-33e1-4a89-9e59-3d34276f8094"
      />

      <Footer />
    </div>
  );
};

export default SanJosePage; 